import apiClient from './client';

export type CopyStatus = 'draft' | 'approved' | 'applied';

export interface ProductCopy {
  id: number;
  shopify_product_id: number;
  product_title: string;
  seo_title: string;
  description: string;
  seo_description: string;
  ai_model: string | null;
  prompt_tokens: number | null;
  completion_tokens: number | null;
  total_tokens: number;
  cost_usd: number;
  status: CopyStatus;
  status_label: string;
  is_editable: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export interface PaginatedProductCopies {
  success: boolean;
  data: ProductCopy[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface ProductCopyFilters {
  status?: string;
  shopify_product_id?: number;
  page?: number;
  per_page?: number;
}

export const productCopyApi = {
  list(filters: ProductCopyFilters = {}): Promise<PaginatedProductCopies> {
    return apiClient.get('/product-copy', { params: filters }).then((r) => r.data);
  },

  find(id: number): Promise<{ success: boolean; data: ProductCopy }> {
    return apiClient.get(`/product-copy/${id}`).then((r) => r.data);
  },

  generate(shopifyProductId: number): Promise<{ success: boolean; data: ProductCopy; message: string }> {
    return apiClient
      .post('/product-copy/generate', { shopify_product_id: shopifyProductId })
      .then((r) => r.data);
  },

  updateStatus(id: number, status: CopyStatus): Promise<{ success: boolean; data: ProductCopy }> {
    return apiClient.patch(`/product-copy/${id}/status`, { status }).then((r) => r.data);
  },

  destroy(id: number): Promise<void> {
    return apiClient.delete(`/product-copy/${id}`).then(() => undefined);
  },
};
